import { render, staticRenderFns } from "./messenger-button.vue?vue&type=template&id=c3fb0fb8"
import script from "./messenger-button.vue?vue&type=script&lang=js"
export * from "./messenger-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports